import React, { useState } from "react";
import axios from "axios";
import { useAuth } from "../../../../contexts/AuthContext";

const CreateStageForm = ({ onSuccess }) => {
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const { apiBaseUrl } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name.trim()) {
      setMessage("لطفاً نام استیج را وارد کنید");
      return;
    }

    setLoading(true);
    setMessage("");

    try {
      const response = await axios.post(
        `${apiBaseUrl}/api/tournament/admin/stages`,
        { name: name.trim() },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );

      setMessage("استیج با موفقیت ایجاد شد");
      setName("");

      // بعد از 1.5 ثانیه به لیست برگرد
      setTimeout(() => {
        onSuccess();
      }, 1500);
    } catch (error) {
      console.error("Error:", error);
      setMessage(error.response?.data?.message || "خطا در ایجاد استیج");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-gray-800 border border-gray-600 rounded-lg p-6">
      <h4 className="text-white font-medium mb-6 text-lg">ایجاد استیج جدید</h4>

      {message && (
        <div
          className={`p-4 rounded-lg text-center mb-4 ${
            message.includes("موفقیت")
              ? "bg-green-900 border border-green-600 text-green-400"
              : "bg-red-900 border border-red-600 text-red-400"
          }`}
        >
          {message}
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-white font-medium mb-2">
            نام استیج:
          </label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="مثال: Speed Run Challenge"
            className="w-full p-3 bg-gray-900 border border-gray-600 rounded-lg text-white placeholder-gray-500 focus:border-green-500 focus:outline-none"
          />
        </div>

        <button
          type="submit"
          disabled={loading || !name.trim()}
          className="w-full py-3 px-6 bg-green-600 hover:bg-green-700 disabled:bg-gray-600 text-white font-medium rounded-lg transition duration-200 flex items-center justify-center gap-2"
        >
          {loading ? (
            <>
              <div className="animate-spin rounded-full h-5 w-5 border-2 border-white border-t-transparent"></div>
              در حال ایجاد...
            </>
          ) : (
            "ایجاد استیج"
          )}
        </button>
      </form>
    </div>
  );
};

export default CreateStageForm;
